/**
 * Видео в историях грузится каскадом: сначала скрипт плеера Kinescope, затем
 * iframe с самим роликом. Скрипт нужен один раз за сессию, поэтому кладём его
 * в кеш заранее — к моменту, когда пользователь дойдёт до видео-слайда, этот
 * шаг каскада уже не выполняется.
 */
const PLAYER_SCRIPT_URL = 'https://player.kinescope.io/latest/iframe.player.js'

let prewarmed = false

/** Положить скрипт плеера в кеш. Повторные вызовы игнорируются. */
export const prewarmVideoPlayer = () => {
  if (prewarmed || typeof document === 'undefined') return
  prewarmed = true
  const link = document.createElement('link')
  // preload только скачивает файл, не выполняя его: побочных эффектов нет.
  link.rel = 'preload'
  link.as = 'script'
  link.href = PLAYER_SCRIPT_URL
  link.crossOrigin = 'anonymous'
  document.head.appendChild(link)
}
